import { render, staticRenderFns } from "./TenantEditLocks.vue?vue&type=template&id=4e8f83cd&scoped=true&"
import script from "./TenantEditLocks.vue?vue&type=script&lang=js&"
export * from "./TenantEditLocks.vue?vue&type=script&lang=js&"
import style0 from "./TenantEditLocks.vue?vue&type=style&index=0&id=4e8f83cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8f83cd",
  null
  
)

export default component.exports